import {Fragment} from "react";
import RemoveCustomFieldContent from "./RemoveCustomFieldContent";
import BasicModal from "../../../../../common/BasicModal";

export default function RemoveCustomFieldModal({title, open, handleClose, customFieldId}) {

    return (
        <Fragment>
            <BasicModal
                title={title}
                open={open}
                style={{width: '500px'}}
                handleClose={handleClose}>

                <RemoveCustomFieldContent
                    handleClose={handleClose}
                    customFieldId={customFieldId}
                />
            </BasicModal>
        </Fragment>
    )
}